<template><!-- svgo-optimised -->
<svg class="icon icon__minus" viewBox="0 0 16 2" xmlns="http://www.w3.org/2000/svg"><path d="M0 .5h16v1H0z"/></svg></template>